export default __webpack_public_path__ + "static/media/kyoto_icon.56c14c89.png";